export default __webpack_public_path__ + "static/media/product-desktop.85f24162.jpg";